import { render, staticRenderFns } from "./TrademarkRenewalsForm.vue?vue&type=template&id=37072956&"
import script from "./TrademarkRenewalsForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkRenewalsForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkRenewalsForm.vue?vue&type=style&index=0&id=37072956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports